import sect1_left from '../../../../assets/images/s2_1_1_sect1_left.png';
import sect1_right from '../../../../assets/images/s2_1_1_sect1_right.png';

import s2_1_3_sect2_img1 from '../../../../assets/images/s2_1_3_sect2_img1.png';
import s2_1_3_sect2_img2 from '../../../../assets/images/s2_1_3_sect2_img2.png';
import s2_1_3_sect2_img3 from '../../../../assets/images/s2_1_3_sect2_img3.png';
import s2_1_3_sect2_img4 from '../../../../assets/images/s2_1_3_sect2_img3.png';

import s2_1_3_sect3_img from '../../../../assets/images/s2_1_3_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 T9</p>
        </div>
        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center m-col-flex between mb-4">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_3_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  사용이 편리한 인터페이스
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  11.6인치 HD 터치스크린과 인체 공학적 디자인으로 <br />
                  고객과 사용자 모두가 쉽게 작동할 수 있습니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center m-col-flex between mb-10">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_1_3_sect2_img2} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  안정적인 서빙
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  멀티링트 댐핑 시스템과 강화된 <br />
                  충격흡수 구조를 통해 안정된 주행을 펼칩니다. <br />
                  새롭게 개발된 PID 컨트롤 알고리즘으로 가속과 제동 및 방향
                  전환이 <br className="t-none" />
                  부드럽고 안정적으로 이루어집니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_1_3_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center m-col-flex between">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_3_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">적재 중량</p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  각 단 10kg씩 최대 40kg의 고중량을 서빙하며, <br />
                  트레이를 탈착하여 높이조정이 가능합니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center m-col-flex between mb-10">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_1_3_sect2_img4} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">자동 충전</p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  매장 업무가 끝난 뒤 자동으로 충전을 하도록
                  <br className="pc-none m-none" /> 설정할 수 있습니다.
                  <br className="t-none" />
                  번거롭지 않게 매출에만 집중하세요.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_1_3_sect2_img4} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 ">
        <div className="center">
          <div className="txt-center mb-4">
            <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
            <p className="prt-bold fs-40 fc-black1 lh-13">
              로봇의 상세 스펙을 확인하세요
            </p>
          </div>

          <div className="flex-center mb-4">
            <img src={s2_1_3_sect3_img} alt="" />
          </div>

          <div className="">
            <div className="flex-center col-flex">
              <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100">
                <div
                  className="row-flex-center between 
                s2_1_1_sect3_inner_box m-w-100 t-w-100"
                >
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">63kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최대 운행 속도</p>
                    <p className="prt-bold fs-28 fc-black1">0.8 m/s</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">40kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 이동폭</p>
                    <p className="prt-bold fs-28 fc-black1">70cm</p>
                  </div>
                </div>
              </div>

              <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
                <div
                  className="row-flex between w-100 lh-14 
                s2_1_1_sect3_inner2_box m-col-flex t-col-flex"
                >
                  <div className="left w-48 m-w-100  t-w-100">
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품크기
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          50.0 × 52.7 × 126.6cm <br />
                          (19.69” × 20.75” × 49.84”)
                        </p>
                      </div>
                    </div>

                    <div className="item  ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최대운행속도
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          0.8 m/s (2.63 ft/s)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          충전시간**
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          4시간
                        </p>
                      </div>
                    </div>

                    <div className="item">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          적재 중량
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          40kg (88 Ibs)
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="right w-48 m-w-100 t-w-100">
                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품무게
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          63kg (139 Ibs)
                        </p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          배터리 수명*
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          완충시 최대 18시간
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          트레이 사이즈
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          49.0 × 40.4cm (19.29” × 15.91”)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최소 운행 폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          70cm (27.56”)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
                  *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
                  실제 결과는 다를 수 있습니다.
                  <br />
                  배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다.
                  배터리 수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
